import cn from '@/utils/cn';

interface TransmissionLineTypeItemProps {
  photo: string;
  badgeLabel: string;
  badgeClassName: string;
  title: string;
  description: string;
}

const TransmissionLineTypeItem = ({
  photo,
  badgeLabel,
  badgeClassName,
  title,
  description,
}: TransmissionLineTypeItemProps) => {
  return (
    <div className="flex w-full items-center gap-3 rounded-[18px] bg-gray-200 p-2.5">
      <img
        src={photo}
        alt=""
        className="size-[90px] shrink-0 rounded-lg object-cover"
      />
      <div className="flex flex-1 flex-col gap-1">
        <span
          className={cn(
            'caption-small w-fit rounded px-2 py-1',
            badgeClassName
          )}
        >
          {badgeLabel}
        </span>
        <p className="h5 text-oxford-blue-500">{title}</p>
        <p className="caption-large text-dark-gray-400">{description}</p>
      </div>
    </div>
  );
};

export default TransmissionLineTypeItem;
